import dayjs from "dayjs";
import service from "../api/api.services";
import { AxiosResponse } from "axios";
import { getAPIURL, getApiUrlForPayroll, getLicenseKey } from "./application.settings";
import noImage from '../assets/img/noImage.png';
import profileForMale from '../assets/img/male.png'
import profileForFemale from '../assets/img/female.png'


const api = service()

export const getGenderDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getGenderDetails/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getGenderDetails - " + error.message)
            console.log('error caught in service : getGenderDetails')
        },
    );

export const getColumnsForDataTable = (userTypeId: number, apiName: string, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void) =>

    api.get(getAPIURL() + `getColumnsForDataTable/${getLicenseKey}/${userTypeId}/${apiName}`,
        response => {
            success(response)
        },
        error => {
            failure("getColumnsForDataTable - " + error.message)
            console.log('error caught in service : getColumnsForDataTable')
        },
    );

export const updateColumnsForDataTable = (columnVisibilityPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateColumnsForDataTable`, columnVisibilityPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateColumnsForDataTable')
        }
    );

export const getGraduationType = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getGraduationType/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getGraduationType - " + error.message)
            console.log('error caught in service : getGraduationType')
        },
    );

export const getSectionDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getSectionDetails/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getSectionDetails - " + error.message)
            console.log('error caught in service : getSectionDetails')
        },
    );

export const getStates = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getStatesAndCity/${getLicenseKey}/0`,
        response => {
            success(response)
        },
        error => {
            failure("getStatesAndCity - " + error.message)
            console.log('error caught in service : getStatesAndCity')
        },
    );

export const getCity = (stateId: number, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getStatesAndCity/${getLicenseKey}/${stateId}`,
        response => {
            success(response)
        },
        error => {
            failure("getStatesAndCity - " + error.message)
            console.log('error caught in service : getStatesAndCity')
        },
    );

export const getBlood = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getBlood/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getBlood - " + error.message)
            console.log('error caught in service : getBlood')
        },
    );

export const getLedger = (ledgerDetailsId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getLedger/${getLicenseKey}/${ledgerDetailsId}`,
        response => {
            success(response)
        },
        error => {
            failure("getLedger - " + error.message)
            console.log('error caught in service : getLedger')
        },
    );

export const getUserType = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getUserType/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getUserType - " + error.message)
            console.log('error caught in service : getUserType')
        },
    );

export const getCategory = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getCategory/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getCategory - " + error.message)
            console.log('error caught in service : getCategory')
        },
    );

export const profilePicUpload = (fileData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `profilePicUpload`, fileData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : profilePicUpload')
        }
    );


export const profilePicUploadForPayroll = (fileData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getApiUrlForPayroll() + `profilePicUpload`, fileData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : profilePicUpload')
        }
    );

export const uploadImageForManualTc = (fileData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `uploadImageForManualTc`, fileData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : uploadImageForManualTc')
        }
    );

export const getReligion = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getReligion/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getReligion - " + error.message)
            console.log('error caught in service : getReligion')
        },
    );

export const getMotherTongue = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getMotherTongue/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getMotherTongue - " + error.message)
            console.log('error caught in service : getMotherTongue')
        },
    );

export const getConcession = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getConcession/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getConcession - " + error.message)
            console.log('error caught in service : getConcession')
        },
    );

export const getQuotaType = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getQuotaType/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getQuotaType - " + error.message)
            console.log('error caught in service : getQuotaType')
        },
    );

export const getQuotaTypeDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getQuotaTypeDetails/${getLicenseKey}/1`,
        response => {
            success(response)
        },
        error => {
            failure("getQuotaTypeDetails - " + error.message)
            console.log('error caught in service : getQuotaTypeDetails')
        },
    );

export const getPaymentConfigDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getPaymentConfigDetails/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getPaymentConfigDetails - " + error.message)
            console.log('error caught in service : getPaymentConfigDetails')
        },
    );

export const checkDataAvailableOrNot = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `checkDataAvailableOrNot/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("checkDataAvailableOrNot - " + error.message)
            console.log('error caught in service : checkDataAvailableOrNot')
        },
    );


export const getModuleType = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getModuleType/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getModuleType - " + error.message)
            console.log('error caught in service : getModuleType')
        },
    );

// Convert Date To Time
export function convertDateToEpoch(fromDate: any) {
    let newFromDate = new Date(fromDate).getTime();
    return newFromDate;
}

// Get Current Time
export function getCurrentDateAndTime(type: any) {
    const today = type == 'date' ? dayjs(new Date()).format('YYYY-MM-DD') : dayjs(new Date()).format('D MMMM, YYYY h:mm A')
    return today;
}

// Date Range
export function convertDateRangeToEpoch(fromDate: any, toDate: any) {
    return Array(new Date(fromDate).getTime(), new Date(toDate).getTime());
}

// Convert Date To Words
export function convertDateToWords(date: any) {


    const toWords = (num: number): string => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        if (num === 0) return 'Zero';

        if (num >= 1000 && num <= 9999) {
            const thousandsDigit = Math.floor(num / 1000);
            const remainder = num % 1000;
            return `${ones[thousandsDigit]} Thousand${remainder !== 0 ? ` ${toWords(remainder)}` : ''}`;
        }

        if (num >= 100 && num <= 999) {
            const hundredsDigit = Math.floor(num / 100);
            const remainder = num % 100;
            return `${ones[hundredsDigit]} Hundred${remainder !== 0 ? ` ${toWords(remainder)}` : ''}`;
        }

        if (num >= 10 && num <= 19) return teens[num - 10];
        if (num >= 20 && num <= 99) {
            const tensDigit = Math.floor(num / 10);
            const onesDigit = num % 10;
            return `${tens[tensDigit]}${onesDigit !== 0 ? ` ${ones[onesDigit]}` : ''}`;
        }

        if (num >= 1 && num <= 9) return ones[num];

        return '';
    };

    const dateParts = date.split('-' || '/');

    const year = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]);
    const day = parseInt(dateParts[2]);

    const yearInWords = toWords(year);
    const monthInWords = toWords(month);
    const dayInWords = toWords(day);

    const dateOfBirthInWord = `${dayInWords} - ${monthInWords} - ${yearInWords}`;
    return dateOfBirthInWord;
};

// only Allow Number
export function onlyAllowNumber(e: any) {
    if (
        !/^[0-9]$/.test(e.key) &&
        !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)
    ) {
        e.preventDefault();
    }
}

// Filter
export function updateFilter(data: any, columnVisibilityData: any, form: any) {

    const filteredData = data.filter((rowData: any) => {
        for (const column of columnVisibilityData) {
            const columnValue = rowData[column.keyName];
            // if (columnValue !== null && columnValue.toString().toLowerCase().includes(form.values.searchInput.toLowerCase())) {
            //     return true;
            // }
            if (columnValue && columnValue !== null && columnValue.toString().toLowerCase().includes(form.values.searchInput.toLowerCase())) {
                return true;
            }
        }
        return false;
    });

    return filteredData;

}

export function onFileSelected(event: any, setSelectedFile: any) {
    const file = event.target.files[0];
    const maxSizeInBytes = 100 * 1024; // 100KB

    if (file && file.size > maxSizeInBytes) {
        setSelectedFile(file);
    } else {
        event.preventDefault();
        alert('Please select a file greater than 100KB.');
    }

}

//// default img 
export function pictNotLoading(event: any, genderId: any) {
    event.target.src = genderId == 2 || genderId == 3 ? profileForFemale : profileForMale;
}

//// Profile img 
export function profilePic(genderId: any) {
    let src = genderId == 2 || genderId == 3 ? profileForFemale : profileForMale;
    return src;
}

/// Select style
export const customStyles = (isDarkMode: any) => ({
    control: (provided: any) => ({
        ...provided,
        fontWeight: 600,
        border: 'transparent',
        backgroundColor: 'transparent',
        boxShadow: 'transparent',
        position: 'absolute',
        top: '10px',
        left: '2px',
        width: 'calc(100% - 6px)',
        height: 'calc(100% - 40px)',
        fontSize: '1rem',
        color: isDarkMode ? '#fff' : '#000', // Dynamic text color
    }),
    clearIndicator: (provided: any) => ({
        ...provided,
        paddingLeft: '10px',
        padding: '5px',
        marginTop: '0px',
        height: '5px',
        position: 'absolute',
        top: '-1px',
        right: '2px',
        color: isDarkMode ? '#fff' : '#000000', // Dynamic text color
        '&:hover': {
            color: isDarkMode ? '#fff' : '#000000',
        }
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        cursor: "pointer",
        lineHeight: '1.5',
        minHeight: '1.2em',
        fontWeight: '500',
        textShadow: "none",
        padding: '1px 15px 1px',
        boxSizing: 'border-box',
        position: 'relative',
        zIndex: 2,
        fontFamily: 'inherit',
        color: isDarkMode ? '#fff' : '#000', // Dynamic text color
        backgroundColor: state.isSelected
            ? (isDarkMode ? '#444' : '#ddd')  // Example selected background color
            : (isDarkMode ? '#333' : '#fff'), // Example background color
        '&:hover': {
            backgroundColor: isDarkMode ? '#007bff' : '#007bff',
            color: isDarkMode ? '#fff' : '#FFFFFF', // Hover color for dark mode and light mode
        }
    }),
    menu: (provided: any) => ({
        ...provided,
        zIndex: 9999,
        overflowY: "auto",
        position: 'absolute',
        fontFamily: 'inherit',
        fontWeight: 'normal',
        color: isDarkMode ? '#fff' : '#000', // Dynamic text color
        backgroundColor: isDarkMode ? '#333' : '#fff', // Dynamic background color
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: () => ({ display: "none" }),
    placeholder: (provided: any) => ({
        ...provided,
        pointerEvents: 'none',
        color: isDarkMode ? '#fff' : '#000', // Dynamic text color
        fontSize: '13px',
        lineHeight: 1,
        paddingBottom: '0.155rem',
        fontFamily: 'inherit'
    }),
    noOptionsMessage: (provided: any) => ({
        ...provided,
        color: isDarkMode ? '#fff' : 'red', // Dynamic text color
        fontFamily: 'inherit',
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: isDarkMode ? '#fff' : '#000000', // Dynamic text color for selected value
    }),
    input: (provided: any) => ({
        ...provided,
        color: isDarkMode ? '#fff' : '#000000', // Change the text color of the input to white for dark mode
    }),
});

export const customStylesForCanvas = (isDarkMode: any) => ({
    control: (provided: any) => ({
        ...provided,
        width: 'calc(100% - 6px)',
        fontSize: '1rem',
        fontWeight: 600,
        lineWeight: 1.5,
        color: '#323232',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'transparent',
        borderRadius: '1rem',
        minHeight: '0px',
        borderStyle: '0px',
        boxShadow: 'transparent',
        padding: 0
    }),
    clearIndicator: (provided: any) => ({
        ...provided,
        paddingLeft: '10px', // Adjust padding left as needed
        padding: '5px',
        marginTop: '0px', // Move the value container up by adjusting the top margin
        height: '1px', // Set the height of the clear indicator
        position: 'absolute', // Adjust position if necessary
        top: '2px', // Adjust top position if necessary
        right: '0px', // Adjust right position if necessary
        color: isDarkMode ? '#fff' : '#000000', // Dynamic text color
        '&:hover': {
            color: isDarkMode ? '#fff' : '#000000',
        }
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        cursor: "pointer",
        lineHeight: '1.5',
        minHeight: '1.2em',
        fontWeight: '500',
        textShadow: "none",
        padding: '1px 15px 1px',
        boxSizing: 'border-box',
        position: 'relative',
        zIndex: 2,
        fontFamily: 'inherit',
        color: isDarkMode ? '#fff' : '#000', // Dynamic text color
        backgroundColor: state.isSelected
            ? (isDarkMode ? '#444' : '#ddd')  // Example selected background color
            : (isDarkMode ? '#333' : '#fff'), // Example background color
        '&:hover': {
            backgroundColor: isDarkMode ? '#007bff' : '#007bff',
            color: isDarkMode ? '#fff' : '#FFFFFF', // Hover color for dark mode and light mode
        }
    }),
    menu: (provided: any) => ({
        ...provided,
        zIndex: 9999, // Increase zIndex to ensure it appears on top of other content
        overflowY: "auto",
        position: 'absolute',
        // maxHeight: "250px",
        // backgroundColor: '#f8f9fa',
        fontFamily: 'inherit',
        fontWeight: 'normal',
        // textShadow: "none",
        color: isDarkMode ? '#fff' : '#000', // Dynamic text color
        backgroundColor: isDarkMode ? '#333' : '#fff', // Dynamic background color
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: () => ({ display: "none" }),
    noOptionsMessage: (provided: any) => ({
        ...provided,
        color: isDarkMode ? '#fff' : 'red', // Dynamic text color
        fontFamily: 'inherit',
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: isDarkMode ? '#fff' : '#000000', // Dynamic text color for selected value
    }),
    input: (provided: any) => ({
        ...provided,
        color: isDarkMode ? '#fff' : '#000000', // Change the text color of the input to white for dark mode
    }),
});

export const formatToSystemDate = (dateString: any) => {
    const date = new Date(dateString);
    // Use Intl.DateTimeFormat with system's default locale
    const formatter = new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    return formatter.format(date);
};